import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Injectable,
  Injector,
} from '@angular/core';

import { ImageResponse } from '@app/api/marketplace/models';

import { ImageCarouselComponent } from './image-carousel.component';

@Injectable({ providedIn: 'root' })
export class ImageCarouselService {
  private component?: ComponentRef<ImageCarouselComponent>;

  constructor(
    private appRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector
  ) {}

  public showCarousel(images: ImageResponse[], baseUrl: string): void {
    if (this.component) {
      return;
    }

    const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(
        ImageCarouselComponent
      );
    this.component = componentFactory.create(this.injector);
    this.component.instance.images = images;
    this.component.instance.baseUrl = baseUrl;
    this.component.instance.closed.subscribe(() => {
      this.hideCarousel();
    });
    this.appRef.attachView(this.component.hostView);
    const domElem = (this.component.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
  }

  private hideCarousel(): void {
    if (this.component) {
      this.appRef.detachView(this.component.hostView);
      this.component.destroy();
      this.component = undefined;
    }
  }
}
